import { graphql } from '../graphql/types';

export const MenuSectionFragment = graphql(`
  fragment MenuSectionItem on MenuSection {
    id
    name
    description
    discountable
    code
    inStock
    enabled
    timeRule {
      __typename
      ... on MenuSectionAlwaysTimeRule {
        type
      }

      __typename
      ... on MenuSectionRangeTimeRule {
        type
        start
        end
        daysOfWeek
        isAllDays
      }
    }
    menuProducts {
      discountable
    }
  }
`);
